import { useContext } from "react";
import { AppContext } from "../App";
import { useNavigate } from "react-router-dom";
import { getCmsPagePath } from "./functions";
import Countdown from "./Countdown";

const getSlideSettings = (settings) => {
	if (!settings) return {};
	if (typeof settings === "object") return settings;
	if (typeof settings === "string") {
		try {
			return JSON.parse(settings);
		} catch {
			return {};
		}
	}
	return {};
};

function Slide({ slide }) {
	const { track, getTranslatedString, pages } = useContext(AppContext);
	const navigate = useNavigate();
	const settings = getSlideSettings(slide.settings);

	const handleSlideAction = (slide) => {
		if (slide.action == "store") {
			navigate("/store");
			track();
		}
		if (slide.action == "reservations") {
			navigate("/booking");
			track();
		}
		if (slide.action == "shops") {
			navigate("/shops");
			track();
		}
		if (slide.action == "page" && slide.page_id) {
			const page = pages.find((item) => item.id == slide.page_id);
			navigate(getCmsPagePath(page || slide.page_id));
			track();
		}
		if (slide.action == "url" && slide.url) {
			if (settings.target_same == 1) window.location.href = slide.url;
			else window.open(slide.url);
		}
		if (slide.action == "news") {
			navigate("/news");
			track();
		}
	};

	return (
		<div
			style={{
				backgroundColor: settings.bg_color ? settings.bg_color : "none",
				backgroundImage:
					slide.content_alignment == "center" ? "url(" + slide.img + ")" : "none",
				minHeight: settings.height
					? "calc(" + settings.height + "dvh - var(--header-h))"
					: "auto",
			}}
			className={"slide " + slide.content_alignment + " slide-" + slide.id}
		>
			{slide.content_alignment !== "center" && slide.img && (
				<div
					className="img"
					style={{
						backgroundImage: "url(" + slide.img + ")",
					}}
				></div>
			)}
			{(slide.title || slide.text || slide.url) && (
				<div
					className="content"
					style={{
						backgroundColor: settings.bg_color
							? settings.bg_color
							: "transparent",
						color: settings.text_color ? settings.text_color : "none",
					}}
				>
					{slide.title && (
						<div
							className="title"
							dangerouslySetInnerHTML={{
								__html: getTranslatedString(slide, "title"),
							}}
						/>
					)}
					{slide.text && (
						<div
							className="text"
							dangerouslySetInnerHTML={{ __html: getTranslatedString(slide, "text") }}
						/>
					)}
					{slide.countdown && (
						<Countdown timeTillDate={slide.countdown} timeFormat="YYYY-MM-DD h:mm:ss" />
					)}
					{slide.action && (
						<button
							style={{
								backgroundColor: settings.btn_bg_color
									? settings.btn_bg_color
									: "none",
								color: settings.btn_text_color
									? settings.btn_text_color
									: "none",
							}}
							onClick={() => handleSlideAction(slide)}
						>
							{getTranslatedString(slide, "button_text")}
						</button>
					)}
				</div>
			)}
		</div>
	);
}

export default Slide;
